module.exports = __webpack_public_path__ + "img/icon-pencil.e506aaf7.svg";